<template>

    <transition
        name="cta-transition"
        enter-active-class="animated delay5s fadeIn"
        leave-active-class="animated delay0s fadeOut">

        <!-- POWER SURGE BUTTON -->
        <div class="power-surge-button noselect" @click.stop="lightsOut" v-if="((hasEntered && display) && !powerSurge) && hasPowerSurge" :title="label">
            <div class="inner">
                <div class="icon"><i :class="icon" aria-hidden="true"></i></div>
                <div class="label">{{ label }}</div>
            </div>
        </div>
        <!-- END POWER SURGE BUTTON -->

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'power-surge-button',

        components: {},

        data() {
            return {
                icon: 'icon-MBR_power-surge',
                label: 'Power Surge',
                display: true
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.state.interactive.entered;
            },

            hasPowerSurge() {
                return this.$dataStore.getters.getPowerSurge.length;
            },

            powerSurge() {
                return this.$dataStore.state.interactive.powerSurge;
            },

            powerSurgeOverlayState() {
                return  this.$dataStore.getters.getPowerSurgeOverlayState;
            }

        },

        created() {
            //console.info('%cPowerSurgeButton::created', 'color:dodgerblue;');

            vm = this;

            this.$eventBus.$on('powersurge:complete', vm.completePowerSurge);
        },

        mounted() {
            //console.info('%cPowerSurgeButton::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            /**
             * @method lightsOut
             * @description
             */
            lightsOut() {

                gtag('event', 'Power Surge Button', {
                    'event_category': 'MBRe: Residential',
                    'event_label': ''
                });

                // zoom out
                this.$eventBus.$emit('residence:zoomout', 1.2);
                // close any active panels
                this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
                // kickoff power surge
                this.$dataStore.dispatch('POWER_SURGE', { val: true });
                this.$dataStore.dispatch('POWER_SURGE_STATE', { val: true });
                this.$eventBus.$emit('power-surge:start');
                // hide points
                this.$eventBus.$emit('points:hide');

                setTimeout(function() {
                    vm.playPowerSurgeAnimations();
                }, 1700);

            },

            playPowerSurgeAnimations() {

                let powerSurgeAnimations = this.$dataStore.getters.getPowerSurgeAnimations;

                let sortedArr = _.orderBy(powerSurgeAnimations, function(o) {
                    return o.animation.powerGridOrder;
                }, ['asc']);

                _.each(sortedArr, function(val, key) {

                    if (key === sortedArr.length - 1) {
                        vm.$dataStore.dispatch('LAST_EXPOSURE_ANIMATION', { val: val.exposure_slug });
                    }

                    setTimeout(function() {
                        vm.$eventBus.$emit('exposure:animate', val.exposure_slug);
                    }, 400 * key);

                });

            },

            completePowerSurge() {
                vm.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: true });

                setTimeout(function() {
                    // toggle panel
                    vm.togglePanel('panel-content-power-surge');
                }, 800);
            },

            /**
             * @method show
             * @description
             */
            show() {
                this.display = true;
            },

            /**
             * @method hide
             * @description
             */
            hide() {
                this.display = false;
            },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             */
            togglePanel(type) {
                this.$eventBus.$emit('panel:toggle', { panel: type });
            },

        }

    }


</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .power-surge-button {
        background-color: rgba(41,41,41, 1.0);
        padding: 8px 10px;
        border-radius: 6px;
        box-shadow: 0 0 2px $black-45;
        display: inline-block;
        overflow: hidden;
        position: fixed;
        top: 50px;
        left: 50px;
        z-index: 999;
        animation-duration: 0.6s;
        animation-delay: 0.3s;
        transition: all 0.3s $easeInOutQuad;

        &:hover {
            background-color: $white-100;
            cursor: pointer;
            transition: all 0.3s $easeInOutQuad;

            & .icon {
                color: rgba(41,41,41, 1.0);
                transition: all 0.3s $easeInOutQuad;
            }

            & .label {
                color: rgba(41,41,41, 1.0);
                transition: all 0.3s $easeInOutQuad;
            }
        }

        & > .inner {
            width: 100%;
            height: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: relative;
        }

        & .icon {
            font-size: 1.188rem;
            color: $white-100;
            padding: 0 6px 0 0;
            flex: 0 0 auto;
            transition: all 0.3s $easeInOutQuad;

            & > i {
                display: block;
            }
        }

        & .label {
            font-family: $font-univers-cond;
            font-size: 0.750rem;
            line-height: 1;
            letter-spacing: 0;
            color: $white-100;
            text-align: left;
            text-transform: uppercase;
            max-width: 100%;
            flex: 1 1 auto;
            transition: all 0.3s $easeInOutQuad;
        }
    }

</style>


// WEBPACK FOOTER //
// PowerSurgeButton.vue?5c505c70